(function(){
    'use strict';

    $('.nav-toggle').on('click', function() {
        var panel = $(this).parents('.nav-item').find('.smp-navigation-dropdown__sub-outer');

        // Close
        if($(this).hasClass('active')) {
            panel.css('max-height', 0);

            setTimeout(() => {
                panel.removeAttr('style');
                $(this).removeClass('hover');
                $(this).removeClass('active');
                panel.removeClass('active');
            }, 700);
        // Open
        } else {
            panel.addClass('active');
            $(this).addClass('active');
        }
    }); 

    // Allow for tabbing - accessibility
    $('.smp-navigation-dropdown .nav-item').each(function() {

        var panel = $(this).find('.smp-navigation-dropdown__sub-outer');

        $(this).keydown(function(e){

            // For when space bar is hit
            if( e.keyCode == 32 ) {
                // Open the dropdown
                if( !panel.hasClass('active')) {

                    panel.addClass('active');
                    panel.siblings().removeClass('active');

                    $(this).addClass('hover');
                    $(this).siblings().removeClass('hover');

                // Close the dropdown
                } else {
                    panel.removeClass('active');
                    $(this).removeClass('hover');
                }

                return false;

            // For when esc is hit
            } else if(e.keyCode == 27) {

                // Close the dropdown
                if( panel.hasClass('active') ) {
                    panel.removeClass('active');
                    $(this).removeClass('hover');
                }

                return false;
            }

        });

    });

}());
